import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services//http/auth/auth.service';
import { UtilService } from '../shared/services/util/util.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private utilService:UtilService) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    //   if (!this.authService.getToken()) {
    //   this.authService.showSuccessMessage({
    //     message: "Please Login First"
    //   })
    //   this.router.navigate(['/auth/login']);
    //   return false;
    // } else {
    //   return true;
    // }

    const requiredRole = route.data['role'];
      
    if (!this.authService.getToken()) {
      // If the user is not logged in, navigate to login page
      // this.authService.showSuccessMessage({ message: "Please Login First" });
      this.utilService.showErrorDialog({
        msg: "Please Login First"
      });
      this.router.navigate(['/auth/login']);
      return false;
    }

    let currentUser = this.authService.getDataFromLocalStorage('user_details');
    currentUser = JSON.parse(currentUser);

    // If the user is logged in and has the correct role
    if (currentUser && currentUser.type == requiredRole) {
      return true;
    }

    // Parent who hasn't selected a child yet — allow into the student dashboard,
    // which shows the child-selection modal over an empty shell.
    if (requiredRole === 'student' && currentUser?.type === 'parent' && localStorage.getItem('parent_children')) {
      return true;
    }

    // If the user is logged in but doesn't have the correct role, redirect to login page or another appropriate page
    this.router.navigate(['/auth/login']);
    return false;
  }

}